import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import { IGameState } from '../Game/IGameState';
import { GameScene } from '../Game/GameScene';
import { PlatformActions, PlatformActionType } from './PlatformActions';
import { PopupID } from '../UI/PopupID';
import UIStateHelper from '../UI/UIStateHelper';
import { SignInState } from './SignInState';
import Game from '../../Game';
import { showQuitGamePopup } from '@platform/State/World/ShowQuitGamePopup';
import { quitGame } from '@platform/Utility/SDK/Game/QuitGame';
import { AsyncActionStatus } from 'State/AsyncAction';
import { RewardType } from 'Utility/Rewards/RewardType';

export const PlatformReducer: Reducer<IGameState> = (state: IGameState, action: ActionType<typeof PlatformActions>) => {
    if (action.type === PlatformActionType.SHOW_QUIT_MENU) {
        return showQuitGamePopup(state);
    } else if (action.type === PlatformActionType.QUIT_GAME) {
        if (
            state.gamePaused ||
            state.UIState.popupID !== PopupID.CONFIRM_QUIT_GAME ||
            state.activeScene.result !== GameScene.WORLD
        )
            return state;

        quitGame();
        return state;
    }

    switch (action.type) {
        case getType(PlatformActions.signOutPrompt):
            return {
                ...state,
                UIState: UIStateHelper.showPopup(state.UIState, PopupID.CONFIRM_SIGN_OUT_MENU, {}),
            };
        case getType(PlatformActions.setSignInState):
            return {
                ...state,
                platform: {
                    ...state.platform,
                    signInState: action.payload,
                },
                UIState: UIStateHelper.hidePopup(state.UIState, PopupID.CONFIRM_SIGN_OUT_MENU, {}),
            };
        case getType(PlatformActions.signInFail):
            return {
                ...state,
                platform: {
                    ...state.platform,
                    signInState: SignInState.SignedOut,
                },
                UIState: UIStateHelper.showPopup(state.UIState, PopupID.ERROR_POPUP, {
                    title: Game.locale.getText('Warning'),
                    body: Game.locale.getText('ConnectionErrorInfo'),
                }),
            };
        case getType(PlatformActions.signInSilentFail):
            return {
                ...state,
                platform: {
                    ...state.platform,
                    signInState: SignInState.SignedOut,
                },
            };
        case getType(PlatformActions.signInSuccess):
            return {
                ...state,
                platform: {
                    ...state.platform,
                    signInState: SignInState.SignedIn,
                },
                UIState: UIStateHelper.hidePopup(state.UIState, state.UIState.popupID, null),
            };
        case getType(PlatformActions.cancelFirebaseSignOut):
            return {
                ...state,
                UIState: UIStateHelper.hidePopup(state.UIState, PopupID.CONFIRM_SIGN_OUT_MENU, {}),
            };
        case getType(PlatformActions.setSignInFacebookReward):
            return {
                ...state,
                platform: {
                    ...state.platform,
                    facebookSignInReward: {
                        status: AsyncActionStatus.QUEUED,
                        result: [
                            {
                                type: RewardType.COINS,
                                value: 5000,
                            },
                        ],
                    },
                },
            };
        case getType(PlatformActions.setFacebookUnified):
            return {
                ...state,
                playerState: {
                    ...state.playerState,
                    isFbInstantUnified: true,
                },
            };
        default:
            return state;
    }
};
